import React from "react";
import { Helmet } from "react-helmet-async";

import { loadScript } from "../../../utils";
import { Game } from "../../models/Game";
import { AppInsightsAnalytics } from "../../services/AppInsight";
import { Analytics } from "../../services/Analytics/Analytics";
import { MarkersKeys, MeasureService } from "../../services/MeasureService";
import "./Preroll.css";

export enum PrerollType {
  PREROLL = "pre-roll",
  REWARD = "reward",
}

type PrerollProps = {
  onEnd: () => void;
  game: Game;
  posterLink: string;
  prerollType?: PrerollType;
};

export class Preroll extends React.Component<PrerollProps> {
  disposed: boolean = false;

  playerId = "NI7d9M1tR";
  account = "6159613157001";
  playerClassName = "vjs-fluid";

  shouldComponentUpdate(nextProps: PrerollProps) {
    return nextProps.posterLink !== this.props.posterLink;
  }

  initPlayer() {
    try {
      const playerContainer = document.querySelector(
        `video[data-player="${this.playerId}"]`
      );
      const player = (window as any).bc(playerContainer.id);
      const startTime = Date.now();

      const btnPlay = document.querySelector(
        'button[class="vjs-big-play-button"]'
      );
      if (btnPlay) {
        btnPlay.addEventListener("click", () => this.trackPrerollStart());
        btnPlay.addEventListener("touchstart", () => this.trackPrerollStart());
        btnPlay.setAttribute("aria-label", "Play Now");
      }

      player.on(["adstart"], (event) => {
        performance.mark(MarkersKeys.AdStart);

        let pe = MeasureService.measure(
          this.props.game,
          MarkersKeys.PlayGameClick,
          MarkersKeys.AdStart
        );
        if (pe) {
          Analytics.trackEvent(
            Analytics.games.performanceMeasure(this.props.game, pe)
          );
          MeasureService.clearMeasures(pe);
        }
      });

      player.on(
        ["ima3error", "ima3-ad-error", "error", "adend", "playing"],
        (event) => {
          console.log(event);
          if (this.disposed) {
            return;
          }
          this.disposed = true;

          player.pause();
          setTimeout(() => {
            player.dispose();
            performance.mark(MarkersKeys.EndOfPreroll);

            Analytics.trackEvent(
              Analytics.games.prerollEnd(
                this.props.game,
                startTime - Date.now()
              )
            );
            this.props.onEnd();
          }, 200);
        }
      );
    } catch (e) {
      console.error(e);
      AppInsightsAnalytics.trackAppError("brightcove init failed", {
        message: e.message,
        stack: e.stack || "",
      });
      this.props.onEnd();
    }
  }

  trackPrerollStart() {
    performance.mark(MarkersKeys.PlayGameClick);
    Analytics.trackEvent(Analytics.games.prerollStart(this.props.game));
  }

  componentDidMount() {
    loadScript(
      `https://players.brightcove.net/${this.account}/${this.playerId}_default/index.min.js`
    ).then(() => setTimeout(() => this.initPlayer(), 1000));
  }

  renderPlayerPoster() {
    return (
      <Helmet>
        <style>
          {`
                        .video-js.bc-player-${this.playerId}_default {
                            background: transparent url("${this.props.posterLink}") 0px 0px / 100% 100% no-repeat;
                        }
                    `}
        </style>
      </Helmet>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderPlayerPoster()}
        <Player>
          <video-js
            data-account={this.account}
            data-player={this.playerId}
            data-embed="default"
            controls={true}
            data-application-id={true}
            className={this.playerClassName}
            src="https://arenax-blobstorage.cdn.arkadiumhosted.com/arenax-index/_arena-shared-content_/tiny3.mp4"
          />
        </Player>
      </React.Fragment>
    );
  }
}

const Player = (props: any) => (
  <div className="player-ark-aarp-container" children={props.children} />
);
